import { PricePoliciesApiRemoteService } from '../../Services/api/price-policies/price-policies-service'
import { IDestroyRulesPoliciesPayload } from '../../Services/api/price-policies/price-policies.interface'
  import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class DestroyPricePoliciesRulesUseCase
implements IFormUsecase<IDestroyRulesPoliciesPayload, void> {
  constructor (private readonly PricePoliciesApi: PricePoliciesApiRemoteService) {}
    

  public async handle (
    data: IDestroyRulesPoliciesPayload
  ): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

        const response = await this.PricePoliciesApi.destroyRule(data)

      if (response.isFailure) {
        return response
      }

    
      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
